import { ChevronUp, ChevronDown, Pencil, Trash2 } from 'lucide-react';

const TYPE_LABEL = { multiple_choice: 'Multiple Choice', true_false: 'True/False' };

/** The list of questions already entered, with reorder and delete. */
export const QuestionList = ({ questions, dimensionNames, editable, onEdit, onDelete, onMove }) => {
  if (!questions.length) {
    return (
      <p className="text-sm text-gray-500" data-testid="question-list-empty">
        No questions yet. Add the first one below.
      </p>
    );
  }

  return (
    <div className="space-y-1.5" data-testid="question-list">
      {questions.map((q, index) => (
        <div
          key={q.id}
          data-testid={`question-row-${q.id}`}
          className="bg-gray-800/50 border border-gray-700 rounded-md px-3 py-2 flex items-start
                     gap-3 hover:border-gray-600 transition-colors"
        >
          <span className="text-xs text-gray-500 w-5 pt-1 shrink-0">{q.order}</span>
          <div className="min-w-0 flex-1">
            <p className="text-sm text-gray-200 truncate">{q.text}</p>
            <p className="text-xs text-gray-500 mt-0.5">
              {dimensionNames[q.dimension] || q.dimension} · {TYPE_LABEL[q.type] || q.type} ·
              {' '}{q.answers.length} options ·
              {' '}weights {q.answers.map((a) => a.weight).join(' / ')}
            </p>
          </div>
          {editable && (
            <div className="flex items-center gap-1 shrink-0">
              <button
                onClick={() => onMove(index, -1)}
                disabled={index === 0}
                data-testid={`question-move-up-${q.id}`}
                className="p-1 text-gray-500 hover:text-cyan-400 disabled:opacity-30
                           disabled:hover:text-gray-500 transition-colors"
                title="Move up"
              >
                <ChevronUp className="w-4 h-4" />
              </button>
              <button
                onClick={() => onMove(index, 1)}
                disabled={index === questions.length - 1}
                data-testid={`question-move-down-${q.id}`}
                className="p-1 text-gray-500 hover:text-cyan-400 disabled:opacity-30
                           disabled:hover:text-gray-500 transition-colors"
                title="Move down"
              >
                <ChevronDown className="w-4 h-4" />
              </button>
              <button
                onClick={() => onEdit(q)}
                data-testid={`question-edit-${q.id}`}
                className="p-1 text-gray-500 hover:text-cyan-400 transition-colors"
                title="Edit"
              >
                <Pencil className="w-4 h-4" />
              </button>
              <button
                onClick={() => onDelete(q)}
                data-testid={`question-delete-${q.id}`}
                className="p-1 text-gray-500 hover:text-red-400 transition-colors"
                title="Delete"
              >
                <Trash2 className="w-4 h-4" />
              </button>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default QuestionList;
